import React, { useState, useEffect, useRef } from "react";
import moment from 'moment';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import LabeledDropdown from "../FamilyDetail/LabeledDropdown";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import "./incentive.scss"
import {
  getAllFamilyDistrict,
  getAllFamilyUphcOrPhc,
  getAllFamilyTaluka,
  getAllFamilyLgb,
  getAllFamilySubcenter,
  getAllFamilyVillageOrSubarea,
} from "../../../../Services/FamilyDashboardService";
import { Button } from "primereact/button";
import { getIncentiveBasedAshaList, getIncentiveBasedAshaSheet, getIncentiveDistrictList, getIncentiveTalukaList, getIncentiveUphcOrPhcList, updateIncentiveActivityStatusService } from "../../../../Services/IncentiveDetails";
import Box from "@mui/material/Box";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { Checkbox } from "@mui/material";
import ActionDialog from "../../../../Components/ActionDialog";
import PdfPreviewDialog from "../../../../Components/PdfPreviewDialog";
import axios from "axios";
import { toast } from "react-toastify";

function TreeLabelWithCheckbox({ label, checked, onChange }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Checkbox
        size="small"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        onClick={(e) => e.stopPropagation()}
      />
      {label}
    </div>
  );
}

function IncentiveView(props) {
  const pdfDialogRef = useRef();
  const { areaType, selectedLanguageId } = props;
  const {
    userRole,
    districtId: districtHead,
    talukaId: talukaHead,
    phcId: phcHead,
    corporation_council_id: corporationHead,
    userCode,
    incentive_role
  } = Object.fromEntries(
    ["userRole", "districtId", "talukaId", "phcId", "corporation_council_id", "userCode", "incentive_role"].map((key) => [
      key,
      sessionStorage.getItem(key),
    ])
  );

  const accessLevel = [
    { id: 1, name: "State" },
    { id: 2, name: "District" },
    { id: 3, name: "Taluka" },
    { id: 4, name: "PHC" },
    { id: 5, name: "UPHC" },
    { id: 6, name: "Corporation" },
    { id: 7, name: "Multi District" },
  ];

  const access_level_id = sessionStorage.getItem("access_level_id");
  const filteredAccessLevel = accessLevel.filter(
    (level) =>
      level.id === Number(access_level_id)
  );

  const accessLevelName = filteredAccessLevel[0].name;
  const [districtOptions, setDistrictOptions] = useState([]);
  const [, setSubcenterOptions] = useState([]);
  const [, setSubareaOptions] = useState([]);
  const [talukaOptions, setTalukaOptions] = useState([]);
  const [phcOptions, setPhcOptions] = useState([]);
  const [incentiveFor, setIncentiveFor] = useState("PENDING");
  const [uphcOptions, setUphcOptions] = useState([]);
  const [lgbOptions, setLgbOptions] = useState([]);
  const [district, setDistrict] = useState("");
  const [taluka, setTaluka] = useState("");
  const [lgb, setLgb] = useState("");
  const [phc, setPhc] = useState("");
  const [uphc, setUphc] = useState("");
  const [village, setVillage] = useState("");
  const [subcenter, setSubcenter] = useState("");
  const [subarea, setArea] = useState("");
  const [, setLevelName] = useState("");
  const [tableData, setTableData] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [activityIncentiveColumns, setActivityIncentiveColumns] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const IS_RURAL = areaType === "Rural" || areaType === "ग्रामीण";
  const IS_URBAN = areaType === "Urban" || areaType === "शहरी";
  const formattedRange = dateRange
    ? dateRange.map(date => moment(date).format('YYYY-MM-DD'))
    : [];
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentNode, setCurrentNode] = useState(null);
  const [talukaData, setTalukaData] = useState({});
  const [phcData, setPhcData] = useState({});
  const [actionDialogVisible, setActionDialogVisible] = useState(false);
  const [actionType, setActionType] = useState("");
  const [remarks, setRemarks] = useState("");
  const [phcIncentiveData, setPhcIncentiveData] = useState({});
  const [phcSelectedRows, setPhcSelectedRows] = useState({});
  const [phcActivitySelection, setPhcActivitySelection] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [activitySelection, setActivitySelection] = useState([]);
  const [, setShouldShowTreeView] = useState(true);
  const [currentPhcId, setCurrentPhcId] = useState(0);
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth + 1);
  const allowedRoles = ["THO", "BLOCK_ACCOUNTANT", "BCM", "PHC_MO"];
  const yearOptions = Array.from({ length: 3 }, (_, i) => {
    const year = currentYear - 2 + i;
    return { label: year.toString(), value: year };
  });
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const monthOptions = (
    selectedYear === currentYear
      ? monthNames.slice(0, currentMonth + 1)
      : monthNames
  ).map((month, index) => ({
    label: month,
    value: index + 1,
  }));
  const getTalukasForDistrict = (districtId) => {
    return talukaData[districtId] || [];
  };
  const handleView = async () => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/approved/ashalist/incentives?areaId=${IS_RURAL ? 2 : 1}&selectedMonth=${selectedMonth}&selectedYear=${selectedYear}&talukaId=${talukaHead}`;

      const response = await axios.get(url, {
        responseType: "blob",
        validateStatus: () => true
      });
      const contentType = response.headers["content-type"];
      if (contentType.includes("application/json")) {
        const text = await response.data.text();
        const json = JSON.parse(text);
        toast.error(json.message || "No data found");
        return;
      }
      const blobUrl = URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      pdfDialogRef.current.open(blobUrl);
    } catch (err) {
      toast.error("Something went wrong while fetching PDF");
    }
  };
  const getPhcsForTaluka = (talukaId) => {
    return phcData[talukaId] || [];
  };
  const getCheckedHierarchy = () => {
    const checkedHierarchy = [];
    const getCheckedPhcs = (talukaId) => {
      const phcs = getPhcsForTaluka(talukaId);
      const checkedPhcs = [];
      phcs.forEach(p => {
        const phcIdKey = `phc-${p.id}`;
        if (checkedItems[phcIdKey] === true) {
          checkedPhcs.push({
            id: p.id,
            name: p.name
          });
        }
      });
      if (checkedItems[`taluka-${talukaId}`] === true) {
        const allPhcsInTaluka = phcs.map(p => ({
          id: p.id,
          name: p.name
        }));
        return { phcs: allPhcsInTaluka, isSelectAll: true };
      }
      const allPhcIds = phcs.map(p => `phc-${p.id}`);
      const isSelectAll = phcs.length > 0 && allPhcIds.every(id => checkedItems[id] === true);
      return { phcs: checkedPhcs, isSelectAll };
    };

    const getCheckedTalukas = (districtId) => {
      const talukas = getTalukasForDistrict(districtId);
      const checkedTalukas = [];
      let allTalukasSelected = talukas.length > 0;
      talukas.forEach(t => {
        const talukaIdKey = `taluka-${t.id}`;
        const { phcs: childPhcs, isSelectAll: isPhcSelectAll } = getCheckedPhcs(t.id);
        if (checkedItems[talukaIdKey] === true || childPhcs.length > 0) {
          checkedTalukas.push({
            id: t.id,
            name: t.name,
            isSelectAll: isPhcSelectAll,
            phcs: childPhcs
          });
        }
        if (checkedItems[talukaIdKey] !== true) {
          allTalukasSelected = false;
        }
      });
      if (checkedItems[`district-${districtId}`] === true) {
        const allTalukasInDistrict = talukas.map(t => {
          const { phcs: allPhcs, isSelectAll: isPhcSelectAll } = getCheckedPhcs(t.id);
          const allPhcsInTaluka = getPhcsForTaluka(t.id).map(p => ({ id: p.id, name: p.name }));
          return {
            id: t.id,
            name: t.name,
            isSelectAll: true,
            phcs: allPhcsInTaluka,
          };
        });
        return { talukas: allTalukasInDistrict, isSelectAll: true };
      }
      return { talukas: checkedTalukas, isSelectAll: allTalukasSelected };
    };
    const initialDistricts = (accessLevelName === "State")
      ? districtOptions
      : (accessLevelName === "District" || accessLevelName === "Multi District") && districtHead
        ? [{ id: Number(districtHead) }]
        : [];
    initialDistricts.forEach(d => {
      const districtIdKey = `district-${d.id}`;
      const { talukas: childTalukas, isSelectAll: isTalukaSelectAll } = getCheckedTalukas(d.id.toString());
      if (checkedItems[districtIdKey] === true || childTalukas.length > 0) {
        checkedHierarchy.push({
          id: d.id,
          name: d.name,
          isSelectAll: isTalukaSelectAll,
          talukas: childTalukas
        });
      }
    });
    if (accessLevelName === "Taluka" && talukaHead) {
      const initialTaluka = talukaOptions.find(t => t.id === Number(talukaHead));
      if (initialTaluka) {
        const { phcs: childPhcs, isSelectAll: isPhcSelectAll } = getCheckedPhcs(talukaHead);
        const talukaIdKey = `taluka-${talukaHead}`;
        if (checkedItems[talukaIdKey] === true || childPhcs.length > 0) {
          checkedHierarchy.push({
            id: Number(districtHead),
            name: "Selected District",
            isSelectAll: false,
            talukas: [
              {
                id: initialTaluka.id,
                name: initialTaluka.name,
                isSelectAll: isPhcSelectAll,
                phcs: childPhcs,
              }
            ]
          });
        }
      }
    }
    return checkedHierarchy;
  };

  const toggleChecked = (itemId, value) => {
    const newCheckedItems = { ...checkedItems };
    const [type, id] = itemId.split("-");
    const numericId = id;
    const setDescendants = (parentId, checked) => {
      newCheckedItems[parentId] = checked;
      const [parentType, parentNumericIdStr] = parentId.split("-");
      if (parentType === "district") {
        getTalukasForDistrict(parentNumericIdStr).forEach(taluka => {
          const talukaId = `taluka-${taluka.id}`;
          setDescendants(talukaId, checked);
        });
      } else if (parentType === "taluka") {
        getPhcsForTaluka(parentNumericIdStr).forEach(phc => {
          const phcId = `phc-${phc.id}`;
          setDescendants(phcId, checked);
        });
      }
    };

    const updateAncestors = (childId) => {
      let parentId = null;
      let siblings = [];

      if (childId.startsWith("taluka-")) {
        for (const dId in talukaData) {
          if (talukaData[dId].some(t => `taluka-${t.id}` === childId)) {
            parentId = `district-${dId}`;
            siblings = getTalukasForDistrict(dId).map(t => `taluka-${t.id}`);
            break;
          }
        }
      } else if (childId.startsWith("phc-")) {
        for (const tId in phcData) {
          if (phcData[tId].some(p => `phc-${p.id}` === childId)) {
            parentId = `taluka-${tId}`;
            siblings = getPhcsForTaluka(tId).map(p => `phc-${p.id}`);
            break;
          }
        }
      }

      if (parentId) {
        const loadedSiblings = siblings.filter(sId => {
          const [s_type, s_id] = sId.split('-');
          if (s_type === 'taluka') return getTalukasForDistrict(parentId.split('-')[1]).some(t => t.id === Number(s_id));
          if (s_type === 'phc') return getPhcsForTaluka(parentId.split('-')[1]).some(p => p.id === Number(s_id));
          return false;
        });
        const allSiblingsChecked = loadedSiblings.length > 0 && loadedSiblings.every(siblingId => newCheckedItems[siblingId] === true);

        const isAnySiblingUnchecked = loadedSiblings.some(siblingId => newCheckedItems[siblingId] === false);
        if (allSiblingsChecked) {
          newCheckedItems[parentId] = true;
        } else if (isAnySiblingUnchecked) {
          newCheckedItems[parentId] = false;
        } else if (loadedSiblings.length > 0 && loadedSiblings.every(siblingId => newCheckedItems[siblingId] === undefined)) {
          newCheckedItems[parentId] = undefined;
        } else {
        }
        updateAncestors(parentId);
      }
    };
    newCheckedItems[itemId] = value;
    if (type === "district" || type === "taluka") {
      setDescendants(itemId, value);
    }
    if (type === "taluka" || type === "phc") {
      updateAncestors(itemId);
    }
    setCheckedItems(newCheckedItems);
  };
  const handleGroupToggle = (group, checked) => {
    setActivitySelection(prev =>
      prev.map(g => {
        if (g.activitygroupname === group.groupName) {
          return {
            ...g,
            selected: checked,
            activities: g.activities.map(a => ({
              ...a,
              selected: checked
            }))
          };
        }
        return g;
      })
    );
  };

  const renderActivityHeader = (group, act) => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Checkbox
        checked={
          activitySelection
            .find(g => g.activitygroupname === group.groupName)
            ?.activities.find(a => a.name === act.header)?.selected || false
        }
        onChange={(e) => handleActivityToggle(group, act, e.target.checked)}
      />
      <label>{act.header}</label>
    </div>
  );

  const handleActivityToggle = (group, act, checked) => {
    setActivitySelection(prev =>
      prev.map(g => {
        if (g.activitygroupname === group.groupName) {
          const updatedActivities = g.activities.map(a =>
            a.name === act.header ? { ...a, selected: checked } : a
          );
          const all = updatedActivities.every(a => a.selected);
          const none = updatedActivities.every(a => !a.selected);
          return {
            ...g,
            selected: all ? true : none ? false : true,
            activities: updatedActivities
          };
        }
        return g;
      })
    );
  };

  const handlePhcActivityToggle = (phcId, groupName, activityName, isChecked) => {
    setPhcIncentiveData(prevData => {
      const phcCache = prevData[phcId];
      if (!phcCache) return prevData;
      const newSelection = phcCache.selection.map(group => {
        if (group.activitygroupname === groupName) {
          if (activityName === null) {
            return {
              ...group,
              selected: isChecked,
              activities: group.activities.map(act => ({
                ...act,
                selected: isChecked
              }))
            };
          }

          const updatedActivities = group.activities.map(act => {
            if (act.name === activityName) {
              return { ...act, selected: isChecked };
            }
            return act;
          });

          const all = updatedActivities.every(a => a.selected);
          const none = updatedActivities.every(a => !a.selected);
          const groupSelected = all ? true : none ? false : true;

          return {
            ...group,
            selected: groupSelected,
            activities: updatedActivities
          };
        }
        return group;
      });

      return {
        ...prevData,
        [phcId]: {
          ...phcCache,
          selection: newSelection
        }
      };
    });
  };
  useEffect(() => {
    if (accessLevelName === "PHC") {
      setPhc(Number(phcHead));
    }
    else if (accessLevelName === "UPHC") {
      setDistrict(Number(districtHead));
      setTaluka(Number(talukaHead));
      setUphc(Number(phcHead));
    } else if (accessLevelName === "Taluka") {
      setDistrict(Number(districtHead));
      setTaluka(Number(talukaHead));
    } else if (accessLevelName === "District" || accessLevelName === "Multi District") {
      setDistrict(districtHead);
    } else if (accessLevelName === "State") {

    }
  }, [userRole, districtHead, talukaHead, phcHead]);

  const exportToExcel = async () => {
    try {
      const selectedHierarchy = getCheckedHierarchy();
      console.log("selectedHierarchy", selectedHierarchy);
      const districtIds = [];
      const talukaIds = [];
      const phcIds = [];

      selectedHierarchy.forEach((district) => {
        // 1️⃣ District level
        if (district.isSelectAll) {
          districtIds.push(district.id);
          return; // skip taluka & phc
        }

        // 2️⃣ Taluka level
        district.talukas?.forEach((taluka) => {
          if (taluka.isSelectAll) {
            talukaIds.push(taluka.id);
            return; // skip phc
          }

          // 3️⃣ PHC level
          if (!taluka.phcs || taluka.phcs.length === 0) {
            return;
          }

          taluka.phcs.forEach((phc) => {
            phcIds.push(phc.id);
          });
        });
      });

      console.log("District IDs:", districtIds);
      console.log("Taluka IDs:", talukaIds);
      console.log("PHC IDs:", phcIds);

      const response = await getIncentiveBasedAshaSheet(
        selectedLanguageId,
        district,
        taluka,
        phc,
        subcenter,
        village,
        lgb,
        areaType,
        uphc,
        subarea,
        corporationHead,
        incentiveFor,
        selectedMonth,
        selectedYear,
        districtIds,
        talukaIds,
        phcIds
      );
      if (response && response.data) {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const now = new Date();
        const timestamp = now
          .toISOString()
          .replace(/[:.]/g, "-")
          .slice(0, 19);
        const filename = `Asha_Incentive_Data_${timestamp}.xlsx`;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (err) {
      console.error("Error downloading Excel:", err);
    }
  };

  useEffect(() => {
    if (currentNode) {
      const [type, id] = currentNode.split("-");

      const loadData = async () => {
        const currentDistrictId = (accessLevelName === "District" || accessLevelName === "Multi District") ? districtHead : id;
        if (
          type === "district" && !talukaData[currentDistrictId]
        ) {
          const talukas = await getIncentiveTalukaList(
            selectedLanguageId,
            currentDistrictId,
            incentiveFor,
            selectedMonth,
            selectedYear,
            incentive_role
          );
          setTalukaData(prev => ({ ...prev, [currentDistrictId]: talukas }));
          return;
        }
        if (type === "taluka" && !phcData[id]) {
          const uphcOrPhcs = await getIncentiveUphcOrPhcList(
            selectedLanguageId,
            id,
            areaType,
            incentiveFor,
            selectedMonth,
            selectedYear,
            incentive_role
          );
          setPhcData(prev => ({ ...prev, [id]: uphcOrPhcs }));
        }
        if (type === "phc") {
          if (phcIncentiveData[id]) {
            return; // Data already loaded/cached for this PHC, no need to re-fetch
          }
          const getAllFamilyTableData = (accessLevelName === "PHC") ? {} : await getIncentiveBasedAshaList(
            selectedLanguageId,
            district,
            taluka,
            id,
            subcenter,
            village,
            lgb,
            areaType,
            uphc,
            subarea,
            corporationHead,
            incentiveFor,
            selectedMonth,
            selectedYear,
          );
          const data = getAllFamilyTableData.data?.data || [];
          let cachedData = { data: data, columns: [], selection: [] };

          if (data.length > 0) {
            const firstRow = data[0];
            const groups = Object.keys(firstRow)
              .filter(key => key.startsWith("act_group_"))
              .map(groupKey => {
                const group = firstRow[groupKey];
                const activities = Object.keys(group)
                  .filter(k => k.startsWith("act_col_"))
                  .map(actKey => ({
                    header: group[actKey].name,
                    groupKey,
                    actKey,
                    activity_masterid: group[actKey].activity_masterid,
                    style: {
                      maxWidth: "250px",
                      wordBreak: "normal",
                      overflowWrap: "normal",
                    }
                  }));
                return {
                  groupName: group.name,
                  activities
                };
              });

            const formattedSelection = groups.map((g, i) => ({
              activitygroupname: g.groupName,
              activitygroupid: i + 1,
              selected: false,
              activities: g.activities.map((a, index) => ({
                name: a.header,
                activityid: index + 1,
                selected: false,
                activity_masterid: a.activity_masterid
              }))
            }));

            cachedData.columns = groups;
            cachedData.selection = formattedSelection;
          }

          setPhcIncentiveData(prev => ({ ...prev, [id]: cachedData }));

        }
      };
      loadData();
    }
    const fetchData = async () => {
      try {
        const stateId = 1;
        if (accessLevelName === "Taluka") {
          setTaluka(Number(talukaHead));
        }
        if (!district && accessLevelName !== "Corporation") {
          const districts = await getIncentiveDistrictList(
            selectedLanguageId,
            stateId,
            incentiveFor,
            selectedMonth,
            selectedYear,
            incentive_role
          );
          setDistrictOptions(districts);
          // const districtOp = await getAllFamilyDistrict(
          //   selectedLanguageId,
          //   stateId
          // );
          // setDistrictOptions(districtOp);
        }
        if ((accessLevelName === "District" || accessLevelName === "Multi District") && districtHead && !talukaData[districtHead]) {
          const talukas = await getIncentiveTalukaList(
            selectedLanguageId,
            districtHead,
            incentiveFor,
            selectedMonth,
            selectedYear,
            incentive_role
          );
          setTalukaData(prev => ({ ...prev, [districtHead]: talukas }));
        }
        if (accessLevelName === "Taluka" && talukaHead && !phcData[talukaHead]) {
          const uphcOrPhcs = await getIncentiveUphcOrPhcList(
            selectedLanguageId,
            talukaHead,
            areaType,
            incentiveFor,
            selectedMonth,
            selectedYear,
            incentive_role
          );
          setPhcData(prev => ({ ...prev, [talukaHead]: uphcOrPhcs }));
        }
        if (!lgb && district && district !== "" && IS_URBAN) {
          const lgbs = await getAllFamilyLgb(selectedLanguageId, areaType);
          setLgbOptions(lgbs);
        }
        if (
          (IS_RURAL && district && district !== "") ||
          (IS_URBAN && lgb == 1)
        ) {
          const talukasOp = await getAllFamilyTaluka(
            selectedLanguageId,
            district
          );
          setTalukaOptions(talukasOp);

          const talukas = await getIncentiveTalukaList(
            selectedLanguageId,
            districtHead,
            incentiveFor,
            selectedMonth,
            selectedYear,
            incentive_role
          );
          setTalukaData(prev => ({ ...prev, [districtHead]: talukas }));
        }
        if (IS_URBAN && lgb && lgb !== "" && lgb !== 1 && !uphc) {
          const uphcOrPhcs = await getAllFamilyUphcOrPhc(
            selectedLanguageId,
            district,
            taluka,
            areaType,
            lgb
          );
          setUphcOptions(uphcOrPhcs);
        } else if (IS_URBAN && lgb === 1 && taluka !== "" && !uphc) {
          const uphcOrPhcs = await getAllFamilyUphcOrPhc(
            selectedLanguageId,
            district,
            taluka,
            areaType,
            lgb
          );
          setUphcOptions(uphcOrPhcs);
        } else if (IS_RURAL && taluka && taluka !== "") {
          const uphcOrPhcsOp = await getAllFamilyUphcOrPhc(
            selectedLanguageId,
            district,
            taluka,
            areaType,
            lgb,
          );
          setPhcOptions(uphcOrPhcsOp);

          const uphcOrPhcs = await getIncentiveUphcOrPhcList(
            selectedLanguageId,
            talukaHead,
            areaType,
            incentiveFor,
            selectedMonth,
            selectedYear,
            incentive_role
          );
          setPhcData(prev => ({ ...prev, [talukaHead]: uphcOrPhcs }));
        }
        if (phc && phc !== "" && !subcenter) {
          const subcenters = await getAllFamilySubcenter(
            selectedLanguageId,
            phc
          );
          setSubcenterOptions(subcenters);
        }
        if (IS_URBAN && uphc && uphc !== "" && !subarea) {
          const subareas = await getAllFamilyVillageOrSubarea(
            selectedLanguageId,
            subcenter,
            uphc
          );
          setSubareaOptions(subareas);
        }
        if (accessLevelName === "Corporation" && IS_URBAN) {
          const uphcOrPhcs = await getAllFamilyUphcOrPhc(
            selectedLanguageId,
            district,
            taluka,
            areaType,
            lgb,
            corporationHead
          );
          setUphcOptions(uphcOrPhcs);
        }
        const getAllFamilyTableData = (accessLevelName !== "PHC") ? {} : await getIncentiveBasedAshaList(
          selectedLanguageId,
          district,
          taluka,
          phc,
          subcenter,
          village,
          lgb,
          areaType,
          uphc,
          subarea,
          corporationHead,
          incentiveFor,
          selectedMonth,
          selectedYear,
        );
        if (
          getAllFamilyTableData.data && Array.isArray(getAllFamilyTableData.data.data) &&
          getAllFamilyTableData.data.data.length > 0
        ) {
          setLevelName(getAllFamilyTableData.data.level);
          setTableData(getAllFamilyTableData.data.data);
          const firstRow = getAllFamilyTableData.data.data[0];
          const groups = Object.keys(firstRow)
            .filter(key => key.startsWith("act_group_"))
            .map(groupKey => {
              const group = firstRow[groupKey];
              const activities = Object.keys(group)
                .filter(k => k.startsWith("act_col_"))
                .map(actKey => ({
                  header: group[actKey].name,
                  groupKey,
                  actKey,
                  activity_masterid: group[actKey].activity_masterid,
                  style: {
                    maxWidth: "250px",
                    wordBreak: "normal",
                    overflowWrap: "normal",
                  }
                }));
              return {
                groupName: group.name,
                activities
              };
            });
          setActivityIncentiveColumns(groups);
          const formatted = groups.map((g, i) => ({
            activitygroupname: g.groupName,
            activitygroupid: i + 1,
            selected: false,
            activities: g.activities.map((a, index) => ({
              name: a.header,
              activityid: index + 1,
              selected: false,
              activity_masterid: a.activity_masterid
            }))
          }));
          setActivitySelection([])
          setActivitySelection(formatted);
          setSelectedRows([])

        } else {
          setLevelName("");
          setTableData([]);
          setActivityIncentiveColumns([]);
          setActivitySelection({});
        }
      } catch (error) { }
    };
    fetchData();
  }, [
    selectedLanguageId,
    district,
    taluka,
    areaType,
    lgb,
    uphc,
    phc,
    subcenter,
    subarea,
    village,
    userRole,
    talukaHead,
    corporationHead,
    selectedMonth,
    selectedYear,
    incentiveFor,
    dateRange,
    currentNode
  ]);
  const styles = {
    container: {
      padding: "10px",
      fontFamily: "Arial, sans-serif",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
    },
    dropdownContainer: {
      marginLeft: "50px",
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "10px",
    },
    content: {
      display: "flex",
      gap: "20px",
    },
    tableContainer: {
      flex: 1,
    },
    statsContainer: {
      flex: 1,
      border: "1px solid #ddd",
      padding: "10px",
    },
    statsHeader: {
      backgroundColor: "#2c3d8f",
      color: "#fff",
      padding: "5px",
      fontWeight: "bold",
      textAlign: "center",
    },
    eligibleCouples: {
      textAlign: "center",
      margin: "10px 0",
    },
    demographics: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      fontSize: "14px",
    },
    chartContainer: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      width: "100%",
      gap: "20px",
    },
    chartItem: {
      width: "48%",
    },
    icon: {
      marginRight: "5px",
    },
    paginatorContainer: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "10px",
    },
  };
  const totalIncentive = tableData.reduce(
    (sum, row) => sum + (Number(row.totalamount) || 0),
    0
  );

  const INCENTIVE_COLUMNS = [
    { header: "Name of Taluka", field: "taluka_name", style: { minWidth: "100px" } },
    { header: "Primary Health Center", field: "phc_name", style: { minWidth: "100px" } },
    { header: "Sub-center", field: "subcenter_names", style: { minWidth: "100px" } },
    { header: "Village", field: "village_names", style: { minWidth: "100px" } },
    { header: "BF's name", field: "bf_name", style: { minWidth: "100px" } },
    { header: "Asha's name", field: "asha_name", style: { minWidth: "100px" } },
    { header: "Total Incentive", field: "totalamount", style: { minWidth: "100px" }, footer: `Total: ${totalIncentive}` },]
  const dropdownConfigs = [
    {
      label: "Excel Export Options",
      placeholder: "Select Export Options",
      options:
        incentive_role === "COMMISSIONER"
          ? [
            { label: "Pending Incentives", value: "PENDING" },
            { label: "Signed Incentives", value: "SIGNED" },
          ]
          : incentive_role === "SFM"
            ? [
              { label: "Pending Incentives", value: "PENDING" },
              { label: "Signed Incentives", value: "SIGNED" },
            ]
            : [
              { label: "Approved Incentives", value: "APPROVED" },
              { label: "Pending Incentives", value: "PENDING" },

              ...(allowedRoles.includes(incentive_role)
                ? [{ label: "Rejected Incentives", value: "REJECTED" }]
                : []),

              ...(["THO", "BLOCK_ACCOUNTANT", "BCM", "PHC_MO"].includes(incentive_role)
                ? [{ label: "Review Incentives", value: "REVIEW" }]
                : []),

              ...(incentive_role === "DF"
                ? [
                  {
                    label: "Signed by Commissioner",
                    value: "COMMISSIONER_SIGNED",
                  },
                  {
                    label: "Signed and Approved",
                    value: "SIGNED",
                  },
                ]
                : []),
            ],
      isMultiple: false,
      state: [
        incentiveFor,
        (value) => {
          setIncentiveFor(value);
          if (accessLevelName === "State") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
            setPhcData([]);
            setTalukaData([]);
            setDistrictOptions([])
          } else if (accessLevelName === "District" || accessLevelName === "Multi District") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
            setPhcData([]);
            setTalukaData([]);
          } else if (accessLevelName === "Taluka") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
            setPhcData([]);
          } else if (accessLevelName === "PHC") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
          }
        },
      ],
      disabled: false,
    },
    {
      label: "Select Year",
      placeholder: "Select Year",
      options: yearOptions,
      visible: true,
      isMultiple: false,
      state: [
        selectedYear,
        (value) => {
          setSelectedYear(value)
          if (value !== currentYear) {
            setSelectedMonth(1);
          } else {
            setSelectedMonth(currentMonth + 1);
          }
          if (accessLevelName === "State") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
            setPhcData([]);
            setTalukaData([]);
            setDistrictOptions([])
          } else if (accessLevelName === "District" || accessLevelName === "Multi District") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
            setPhcData([]);
            setTalukaData([]);
          } else if (accessLevelName === "Taluka") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
            setPhcData([]);
          } else if (accessLevelName === "PHC") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
          }
        }

      ],
      disabled: false,
    },
    {
      label: "Select Month",
      placeholder: "Month",
      options: monthOptions,
      visible: true,
      isMultiple: false,
      state: [
        selectedMonth,
        (value) => {
          setSelectedMonth(value)
          if (accessLevelName === "State") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
            setPhcData([]);
            setTalukaData([]);
            setDistrictOptions([])
          } else if (accessLevelName === "District" || accessLevelName === "Multi District") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
            setPhcData([]);
            setTalukaData([]);
          } else if (accessLevelName === "Taluka") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
            setPhcData([]);
          } else if (accessLevelName === "PHC") {
            setPhcSelectedRows([]);
            setPhcActivitySelection([]);
            setPhcIncentiveData([]);
            setTableData([]);
          }
        },
      ],
      disabled: false,
    }

  ];

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="" colSpan={1} />
        <Column header="" colSpan={4} />
        <Column header="" colSpan={3} />
        {activityIncentiveColumns.map(group => (
          <Column
            key={group.groupName}
            colSpan={group.activities.length}
            header={
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <Checkbox
                  checked={activitySelection.find(g => g.activitygroupname === group.groupName)?.selected || false}
                  onChange={(e) => handleGroupToggle(group, e.target.checked)}
                />
                <span>{group.groupName}</span>
              </div>
            }
          />
        ))}
      </Row>
      <Row>
        <Column
          header="Select"
          selectionMode="multiple"
          headerStyle={{ width: '3rem' }}
          style={{ width: '3rem' }}
        />
        {INCENTIVE_COLUMNS.map(col => (
          <Column
            key={col.field}
            header={col.header}
            field={col.field}
            style={col.style}
          />
        ))}
        {activityIncentiveColumns.flatMap(group =>
          group.activities.length > 0
            ? group.activities.map(act => (
              <Column
                key={`${act.groupKey}_${act.actKey}`}
                header={renderActivityHeader(group, act)}
                style={act.style}
                body={(rowData) =>
                  rowData?.[act.groupKey]?.[act.actKey]?.calculated_amount ?? ""
                }
              />
            ))
            : [
              <Column
                key={`${group.groupName}_empty`}
                header="No Activities"
                body={() => ""}
              />
            ]
        )}
      </Row>
    </ColumnGroup>
  );
  React.useEffect(() => {
    Object.keys(phcIncentiveData).forEach(phcId => {
      const phcCache = phcIncentiveData[phcId];
      if (!phcCache?.selection) return;

      const phcSelection = phcCache.selection.map(group => ({
        activitygroupid: group.activitygroupid,
        activitygroupname: group.activitygroupname,
        selected: group.selected === true,
        activities: group.activities.map(act => ({
          activity_masterid: act.activity_masterid,
          name: act.name,
          selected: act.selected === true
        }))
      }));

      setPhcActivitySelection(prev => ({
        ...prev,
        [phcId]: phcSelection
      }));
    });
  }, [phcIncentiveData]);
  const renderPhcDataTable = (phcId) => {
    const phcCache = phcIncentiveData[phcId];

    if (!phcCache || !phcCache.data || phcCache.data.length === 0) {
      return <div style={{ padding: "10px" }}>No incentive data found for this PHC.</div>;
    }

    const localTableData = phcCache.data;
    const localActivityIncentiveColumns = phcCache.columns;
    const localSelectedRows = phcSelectedRows[phcId] || [];

    const localTotalIncentive = localTableData.reduce(
      (sum, row) => sum + (Number(row.totalamount) || 0),
      0
    );

    const handlePhcSelectionChange = (e) => {
      const formatted = e.value.map(row => ({
        activityid: row.activityid,
        activitymasterid_array: row.activitymasterid_array
      }));

      setPhcSelectedRows(prev => ({
        ...prev,
        [phcId]: formatted
      }));
    };

    const handlePhcAction = (type) => {
      const rowsToActOn = phcSelectedRows[phcId] || [];
      if (rowsToActOn.length === 0) return;

      setActionType(type);
      setRemarks("");
      setCurrentPhcId(phcId);
      setSelectedRows(rowsToActOn);
      setActivitySelection(phcActivitySelection[phcId] || []);

      setActionDialogVisible(true);
    };

    const localIncentiveColumns = INCENTIVE_COLUMNS.map(col => {
      if (col.field === "totalamount") {
        return {
          ...col,
          footer: `Total: ${localTotalIncentive.toFixed(2)}`
        };
      }
      return col;
    });

    const isActivitySelected = (groupName, activityName) => {
      const group = phcCache.selection.find(g => g.activitygroupname === groupName);
      if (!group) return false;
      const activity = group.activities.find(a => a.name === activityName);
      return activity ? activity.selected : false;
    };
    const localHeaderGroup = (
      <ColumnGroup>
        <Row>
          <Column header="" colSpan={localIncentiveColumns.length + 1} />
          {localActivityIncentiveColumns.map(group => {
            const groupSelection = phcCache.selection.find(s => s.activitygroupname === group.groupName) || { selected: false };

            return (
              <Column
                key={group.groupName}
                colSpan={group.activities.length}
                header={
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <Checkbox
                      checked={groupSelection.selected}
                      onChange={(e) =>
                        handlePhcActivityToggle(phcId, group.groupName, null, e.target.checked)
                      }
                    />
                    <span>{group.groupName}</span>
                  </div>
                }
              />
            );
          })}
        </Row>
        <Row>
          <Column
            header="Select"
            selectionMode="multiple"
            headerStyle={{ width: '3rem' }}
            style={{ width: '3rem' }}
          />

          {localIncentiveColumns.map(col => (
            <Column
              key={col.field}
              header={col.header}
              field={col.field}
              style={col.style}
            />
          ))}

          {localActivityIncentiveColumns.flatMap(group =>
            group.activities.length > 0
              ? group.activities.map(act => (
                <Column
                  key={`${act.groupKey}_${act.actKey}`}
                  header={
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <Checkbox
                        checked={isActivitySelected(group.groupName, act.header)}
                        onChange={(e) =>
                          handlePhcActivityToggle(phcId, group.groupName, act.header, e.target.checked)
                        }
                      />
                      <span>{act.header}</span>
                    </div>
                  }
                  style={act.style}
                  body={(rowData) =>
                    rowData?.[act.groupKey]?.[act.actKey]?.calculated_amount ?? ""
                  }
                />
              ))
              : []
          )}
        </Row>
      </ColumnGroup>
    );

    const canApproveAndSign =
      (incentiveFor === "PENDING" &&
        ["COMMISSIONER", "SFM"].includes(incentive_role)) ||
      (incentiveFor === "COMMISSIONER_SIGNED" &&
        incentive_role === "DF");

    const buttonLabel = canApproveAndSign ? "Approve & Sign" : "Approve";

    const actionType = canApproveAndSign ? "SIGNED" : "APPROVED";
    const localPaginatorRight = (
      <div className="flex justify-content-end gap-2" style={{ width: "100%" }}>
        <Button
          label={buttonLabel}
          icon="pi pi-check"
          className="p-button-success p-button-sm"
          onClick={() => handlePhcAction(actionType)}
          disabled={localSelectedRows.length === 0 || !["COMMISSIONER_SIGNED", "SFM_SIGNED", "PENDING"].includes(incentiveFor)}
        />
        {allowedRoles.includes(incentive_role) && (
          <Button
            label="Reject"
            icon="pi pi-times"
            className="p-button-danger p-button-sm"
            onClick={() => handlePhcAction("REJECTED")}
            disabled={localSelectedRows.length === 0 || !['PENDING'].includes(incentiveFor)}
          />
        )}
        {allowedRoles.includes(incentive_role) && (
          <Button
            label="Review"
            icon="pi pi-search"
            className="p-button-info p-button-sm"
            onClick={() => handlePhcAction("REVIEW")}
            disabled={localSelectedRows.length === 0 || incentiveFor !== "PENDING"}
          />
        )}
      </div>
    );
    return (
      <DataTable
        data-testid={`phc-table-${phcId}`}
        resizableColumns
        value={localTableData}
        size="small"
        filterDisplay="row"
        dataKey="activityid"
        selectionMode="checkbox"
        selection={localSelectedRows}
        onSelectionChange={handlePhcSelectionChange}
        emptyMessage="No data found."
        scrollable
        scrollHeight="400px"
        paginator
        rows={10}
        rowsPerPageOptions={[10, 20, 50, 100]}
        paginatorLeft={localPaginatorRight}
        showGridlines
        headerColumnGroup={localHeaderGroup}
        className={`my-incentive-table phc-table-${phcId}`}
      >
        <Column
          header="Select"
          selectionMode="multiple"
          headerStyle={{ width: '3rem' }}
          style={{ width: '3rem' }}
        />

        {localIncentiveColumns.map((col) => (
          <Column
            key={col.field}
            header={col.header}
            field={col.field}
            body={col.body}
            style={col.style}
            frozen={col.frozen}
            footer={col.footer}
          />
        ))}

        {localActivityIncentiveColumns.flatMap(group =>
          group.activities.length > 0
            ? group.activities.map(act => (
              <Column
                key={`${act.groupKey}_${act.actKey}`}
                header={act.header}
                style={act.style}
                body={(rowData) =>
                  rowData?.[act.groupKey]?.[act.actKey]?.calculated_amount ?? ""
                }
              />
            ))
            : [
              <Column
                key={`${group.groupName}_empty`}
                header="No Activities"
                body={() => ""}
              />
            ]
        )}
      </DataTable>
    );
  };
  const renderPhcTree = (talukaItem) => {
    const talukaId = talukaItem;
    if (!phcData[talukaId]) {
      return <TreeItem itemId={`phc-loading-${talukaId}`} label="Loading..." />;
    }
    return phcData[talukaId].map((p) => (
      <TreeItem
        key={p.id}
        itemId={`phc-${p.id}`}
        label={
          <TreeLabelWithCheckbox
            label={p.name}
            checked={!!checkedItems[`phc-${p.id}`]}
            onChange={(v) => toggleChecked(`phc-${p.id}`, v)}
          />
        }
      >
        {phcIncentiveData[p.id] ? (
          <div style={{ padding: "10px" }}>
            {renderPhcDataTable(p.id)}
          </div>
        ) : (
          <TreeItem itemId={`${p.id}-loading`} label="Loading..." />
        )}
      </TreeItem>
    ));
  };
  const renderTalukaTree = (districtItem) => {
    const districtId = districtItem;
    if (!talukaData[districtId]) {
      return <TreeItem itemId={`taluka-loading-${districtId}`} label="Loading..." />;
    }
    return talukaData[districtId].map((t) => (
      <TreeItem
        key={t.id}
        itemId={`taluka-${t.id}`}
        label={
          <TreeLabelWithCheckbox
            label={t.name}
            checked={!!checkedItems[`taluka-${t.id}`]}
            onChange={(v) => toggleChecked(`taluka-${t.id}`, v)}
          />
        }
      >
        {renderPhcTree(t.id)}
      </TreeItem>
    ));
  };
  const handleAction = (action) => {
    if (selectedRows.length === 0) {
      alert(`Please select at least one row to ${action}.`);
      return;
    }

    setActionType(action);
    setRemarks("");
    setActionDialogVisible(true);
  };
  const getSelectedActivityMasterIds = () => {
    const selectedIds = [];
    const currentSelection = incentive_role !== 'PHC_MO'
      ? phcActivitySelection[currentPhcId] || []
      : activitySelection;

    currentSelection.forEach(group => {
      if (group.selected) {
        group.activities.forEach(act => {
          if (act.selected) {
            selectedIds.push(act.activity_masterid);
          }
        });
      }
    });

    return selectedIds;
  };


  const handleSubmitAction = async () => {

    const selectedActivityMasterIds = getSelectedActivityMasterIds();

    const rowsToProcess =
      incentive_role === "PHC_MO"
        ? selectedRows
        : phcSelectedRows[currentPhcId] || [];

    if (!rowsToProcess || rowsToProcess.length === 0) {
      console.error("No rows to process.");
      return;
    }

    const incentiveActivityData = rowsToProcess.map(row => {
      const filteredIds = selectedActivityMasterIds.filter(id =>
        row.activitymasterid_array?.includes(id)
      );

      return {
        activityid: row.activityid,
        activitymasterid: filteredIds
      };
    });

    const finalPayload = {
      remark: remarks,
      incentiveActivityData
    };

    try {
      await updateIncentiveActivityStatusService(
        finalPayload,
        userCode,
        actionType,
        incentive_role,
        incentiveFor
      );

      setSelectedRows([]);
      setPhcSelectedRows({});
      setActivitySelection([]);
      setActionType("");
      setCurrentPhcId(null);
      setActionDialogVisible(false);

      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error("API Update Error:", error);
    }
  };

  const renderDataTable = () => {
    const customPaginatorRight = (
      <div className="flex justify-content-end gap-2" style={{ width: "100%" }}>
        <Button
          label="Approve"
          icon="pi pi-check"
          className="p-button-success p-button-sm"
          onClick={() => handleAction("APPROVED")}
          disabled={selectedRows.length === 0 || incentiveFor !== "PENDING"}
        />
        <Button
          label="Reject"
          icon="pi pi-times"
          className="p-button-danger p-button-sm"
          onClick={() => handleAction("REJECTED")}
          disabled={selectedRows.length === 0 || !['PENDING', 'REVIEW'].includes(incentiveFor)}
        />
        {/* <Button
      label="Review"
      icon="pi pi-search"
      className="p-button-info p-button-sm"
      onClick={() => handleAction("REVIEW")}
      disabled={selectedRows.length === 0 || !['PENDING', 'REVIEW'].includes(incentiveFor)}
    /> */}
      </div>
    );
    return (
      <DataTable
        data-testid="family-details-table"
        resizableColumns
        value={tableData || []}
        size="small"
        filterDisplay="row"
        dataKey="activityid"
        selectionMode="checkbox"
        selection={selectedRows}
        onSelectionChange={(e) => {
          const formatted = e.value.map(row => ({
            activityid: row.activityid, activitymasterid_array: row.activitymasterid_array
          }));

          setSelectedRows(formatted); // Your new formatted array
        }}
        emptyMessage="No data found."
        scrollable
        scrollHeight="510px"
        paginator
        rows={10}
        rowsPerPageOptions={[10, 20, 50, 100]}
        paginatorLeft={customPaginatorRight}
        showGridlines
        headerColumnGroup={headerGroup}
        className="my-incentive-table"
      >
        <Column
          header="Select"
          selectionMode="multiple"
          headerStyle={{ width: '3rem' }}
          style={{ width: '3rem' }}
        />
        {INCENTIVE_COLUMNS.map((col) => (
          <Column
            key={col.field}
            header={col.header}
            field={col.field}
            body={col.body}
            style={col.style}
            frozen={col.frozen}
            footer={col.footer}
          />
        ))}
        {activityIncentiveColumns.flatMap(group =>
          group.activities.length > 0
            ? group.activities.map(act => (
              <Column
                key={`${act.groupKey}_${act.actKey}`}
                header={act.header}
                style={act.style}
                body={(rowData) =>
                  rowData?.[act.groupKey]?.[act.actKey]?.calculated_amount ?? ""
                }
              />
            ))
            : [
              <Column
                key={`${group.groupName}_empty`}
                header="No Activities"
                body={() => ""}
              />
            ]
        )}
      </DataTable>
    );
  };
  const renderTreeViewContent = () => {
    switch (accessLevelName) {
      case "State":
        return districtOptions.map((d) => (
          <TreeItem
            key={d.id}
            itemId={`district-${d.id}`}
            label={
              <TreeLabelWithCheckbox
                label={d.name}
                checked={!!checkedItems[`district-${d.id}`]}
                onChange={(v) => toggleChecked(`district-${d.id}`, v)}
              />
            }
          >
            {renderTalukaTree(d.id)}
          </TreeItem>
        ));
      case "District":
      case "Multi District":
        if (!Number(districtHead)) return <TreeItem itemId="loading-district" label="No Data Found" />;
        return renderTalukaTree(Number(districtHead));
      case "Taluka":
        if (!Number(talukaHead)) return <TreeItem itemId="loading-taluka" label="No Data Found" />;
        return renderPhcTree(Number(talukaHead));
      case "PHC":
      case "UPHC":
      case "Corporation":
      default:
        return null;
    }
  };
  const shouldShowTreeView = ["State", "District", "Multi District", "Taluka"].includes(accessLevelName);
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <div style={styles.dropdownContainer}>
            {dropdownConfigs.map((config, index) => (
              <React.Fragment key={index}>
                <LabeledDropdown
                  label={config.label}
                  placeholder={config.placeholder}
                  options={config.options}
                  visible={config.visible}
                  value={config.state[0]}
                  onChange={config.state[1]}
                  disabled={config.disabled}
                  isMultiple={config.isMultiple}
                />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      <div style={styles.content}>
        <div style={styles.tableContainer}>
          <div className="flex justify-content-start align-items-center mb-3 gap-2">
            <Button
              label="Export to Excel"
              icon="pi pi-file-excel"
              className="p-button-success"
              onClick={exportToExcel}
            />
            {(incentive_role === "BLOCK_ACCOUNTANT" || incentive_role === "THO") && (
              <>
                <Button
                  label="View SFM Approved"
                  icon="pi pi-eye"
                  className="p-button-info"
                  onClick={handleView}
                />
              </>
            )}
          </div>
          {shouldShowTreeView ? (
            <Box sx={{ minHeight: 352, minWidth: 290 }}>
              <SimpleTreeView
                expanded={expanded}
                onItemExpansionToggle={(event, itemId, isExpanded) => {
                  if (isExpanded) {
                    setCurrentNode(itemId);
                    setExpanded(prev => [...prev, itemId]);
                  } else {
                    setExpanded(prev => prev.filter(id => id !== itemId));
                  }
                }}
              >
                {renderTreeViewContent()}
              </SimpleTreeView>
            </Box>
          ) : (
            <div style={{ padding: "10px" }}>
              {renderDataTable()}
              <div style={styles.paginatorContainer}></div>
            </div>
          )}
        </div>
      </div>
      <ActionDialog
        visible={actionDialogVisible}
        actionType={actionType}
        onHide={() => setActionDialogVisible(false)}
        onSubmit={handleSubmitAction}
        remarks={remarks}
        setRemarks={setRemarks}
      />
      <PdfPreviewDialog
        ref={pdfDialogRef} dialogHeader="Asha Incentive List"
      />
    </div>
  );
}

export default IncentiveView;